<template>
  <div>
    <!--Rows-->
    <ValidationObserver ref="observer" name="participants">
      <div class="participant-signatures bg-secondary-3 border-radius--light">
        <div v-for="(item, index) in value" :key="index">
          <ParticipantSignaturesRow
            :id="item.id"
            ref="signatureRow"
            class="participant"
            :is-disabled="!isDraft || item.isDisabled || readOnly"
            :is-required="item.isRequired"
            :value="item.signature"
            :is-removable="item.isRemovable && isDraft"
            :position-disabled="item.positionDisabled"
            :options="filterOptions(item.groupId)"
            :group-name="getGroupName(item)"
            :participation-types="participationTypes"
            :participation-disabled="item.participationDisabled"
            :alternate-participations="alternateParticipations"
            :fullname-only="fullnameOnly"
            @update:participationTypes="
              () => $emit('update:participationTypes', value.participationId)
            "
            @deleteSignature="deleteSignature"
          />
        </div>
      </div>
    </ValidationObserver>
    <div v-if="isDraft && !readOnly" class="text-right mt-4">
      <div class="mx-0 bd-highlight ml-2">
        <ActionButton
          :variant="isMobile ? 'success btn-block' : 'success'"
          class="px-1 actions p-2 m-2"
          i="fas fa-file-plus"
          @click="addSignature()"
        >
          A&ntilde;adir
        </ActionButton>
      </div>
      <Error
        v-if="infoMessage != undefined && infoMessage != ''"
        class="m-2"
        is-alert-mode
        :message="infoMessage"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.participant-signatures {
  .participant {
    padding: 1rem;
  }
  .participant:not(:first-child) {
    border-top: 2px solid gray;
  }
}
</style>

<script>
// import Vue from "vue";
import ParticipantSignaturesRow from '@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignaturesRow';
import ActionButton from 'ActionButton';
import { ValidationObserver } from 'vee-validate';
import Error from '@/components/common/Error.vue';

export default {
  name: 'Tab9ParticipantSignatures',
  components: {
    ParticipantSignaturesRow: ParticipantSignaturesRow,
    ActionButton,
    ValidationObserver,
    Error,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    signatures: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    participationTypes: {
      type: Array,
      default: () => [],
    },
    alternateParticipations: {
      type: Array,
      default: () => [],
    },
    infoMessage: {
      type: String,
      default: '',
    },
    allowedGroupList: {
      type: Array,
      default: () => [1, 4, 5, 15, 16],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    fullnameOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    addSignature() {
      this.$emit('addSignature');
    },
    deleteSignature(id) {
      this.$emit('deleteSignature', id);
    },
    filterOptions(groupId) {
      if (groupId != 0) {
        const filteredOptions = this.options.filter(
          (x) => x.signatureGroupId == groupId
        );
        return filteredOptions;
      }

      const filteredOptions = this.options.filter((x) =>
        this.allowedGroupList.some((g) => x.signatureGroupId == g)
      );

      const defualtSignatures = this.options.filter(
        (x) =>
          x.signatureGroupId == 13 &&
          !filteredOptions.some(
            (g) => g.signaturePositionId == x.signaturePositionId
          )
      );

      return filteredOptions.concat(defualtSignatures);
    },
    getGroupName(item) {
      let groupId =
        item.signature?.positionId?.signatureGroupId || item.groupId;
      // JSF: Si el groupId viene 0 es que estan agregando una agencia desde la seccion de la parte
      // (IX. Participación de la familia y otras agencias del TAB 9). Asi que añadimos un nombre por defecto
      // porque no encontrara el nombre del grupo.
      const defaultSignatureGroupName =
        groupId === 0 || groupId === 13
          ? 'Otras personas con experiencia o peritaje'
          : '';

      const signatureGroup = this.options.find(
        (x) => x.signatureGroupId == groupId
      );
      if (signatureGroup && item.groupId === 0) {
        item.groupId = signatureGroup.signatureGroupId;
      }

      return defaultSignatureGroupName || signatureGroup?.signatureGroupName;
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
};
</script>
